import workspace from "../../workspace";
import COLOR_THEMES, {COLOR} from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import {
  RENDER_TEMPLATES, SHAPE_PART_ID,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS
} from "../../../../../constants";
import config from "../../../store/sqftConfig";
import sqftShapeManager from "../../../store/sqftShapeManager";
import RenderParts from "../../../helpers/renderParts";
import RenderFigures from "../../../helpers/renderFigures";
import store from "../../../../../../../store";
import RenderCabinets from "../../../helpers/renderCabinets";
import {COLORS} from "../../../../../../../colorThemes";
import Config from "../../../../../../../config";
import {canShapeBeAutoShifted} from "../../../../../helpers/shapeHelper";
import {getPointField} from "../../../../../helpers/sqftHelper";

class ShapeCabinet {
  __shape;
  __crownMoldingFeatureId = null;
  __crownMoldingParams = {
    distance: 10
  }

  constructor(shape) {
    this.__shape = shape;
  }

  import = (data) => {
    void data
  }

  export = () => {
    return {
      width: this.getShapeWidth(),
      height: this.getShapeHeight(),
      depth: this.getShapeDepth(),
    }
  }

   getShapeWidth = () => {
     return this.__shape.getWidth(true);
  }

  getShapeDepth = () => {
    return this.__shape.getDepth(true);
  }

  getShapeHeight = () => {
    return this.__shape.getHeight(true);
  }

  addCrownMolding = () => {
    const state = store.getState();
    const selectedFeature = state.sqftResourceState.selectedFeature;
    this.__crownMoldingFeatureId = selectedFeature ? selectedFeature.part.dbFeature.id : null
    console.log("this.__crownMoldingFeatureId", this.__crownMoldingFeatureId);
  }

  render = (ctx, staticOffset = null, template= RENDER_TEMPLATES.default) => {
    if (workspace && workspace.getState().loading) return;

    this.renderBorders(ctx, staticOffset, template);
    this.renderDimensionsInsideShape(ctx);
    RenderParts.drawShapeCrownMoldings(ctx, staticOffset, this.__shape);
    this.renderHandles(ctx);
    //if (!this.__shape.shapeAbsolute.getAbsolutePosition() && !this.__shape.shapeAbsolute.getSnappedWithShape()) {
    if (this.__shape.shapeAbsolute.getSnappedShapeGroup() === null) {
      //this.renderCrownMolding(ctx);
      this.renderDimensionsOutsideShape(ctx);
    }
    if (Config.isDevMode()) {
      this.renderTestShapeLines(ctx, staticOffset, template);
      this.renderShapeSnappedGroup(ctx, staticOffset, template);
    }
  }

  renderMeasurementArrows = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderFigures.drawArrowsAroundPoints(ctx, points, 10);
  }

  renderTestShapeLines = (ctx) => {
    if (this.__shape.testShapeLines) {
      ctx.save();
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = COLORS.gray;
      for (const testShapeLine of this.__shape.testShapeLines) {
        ctx.moveTo(testShapeLine.from.x, testShapeLine.from.y);
        ctx.lineTo(testShapeLine.to.x, testShapeLine.to.y);
      }
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }
  }

  renderShapeSnappedGroup = (ctx) => {
    // render shape group
    let shapeCenter = this.__shape.getCenter();
    const pos = getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    const renderText = this.__shape.shapeAbsolute.getSnappedShapeGroup() + ".gr";
    const mText = ctx.measureText(renderText);
    ctx.wrapText(renderText, pos.x, pos.y, mText, 22);
  }

  renderMeasurementLength = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderParts.drawMeasurementAroundPoints(ctx, points);
  }

  renderDimensionsOutsideShape = (ctx) => {
    ctx.save();
    ctx.beginPath();
    this.renderMeasurementArrows(ctx);
    this.renderMeasurementLength(ctx);
    ctx.closePath();
    ctx.restore();
  }

  renderDimensionsInsideShape = (ctx) => {
    const shapeWidth = this.getShapeWidth();
    const shapeHeight = this.getShapeHeight();
    const textWidth = 'W: ' + shapeWidth;
    const textHeight = 'H: ' + shapeHeight;
    const fontSize = config.workspace.fontSizeSmallest;// * config.scale / config.defaultScale;
    const font = fontSize + "px " + config.activeFontRegular;
    const mTextWidth = ctx.measureText(textWidth);
    const mTextHeight = ctx.measureText(textWidth);
    const {minX, maxX, minY, maxY} = sqftShapeManager.getMinMaxShapePoints(this.__shape,true, true);
    void minY;
    //middle of the bottom line
    let pos = {
      x: minX + (maxX - minX) / 2 - mTextWidth.width / 2,
      y: maxY - fontSize
    };

    // center position
    // let shapeCenter = ShapeHelper.getCenterPoint(points);
    // let shapeCenterOnField =  getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    // let pos = {
    //   x: shapeCenterOnField.x - mTextWidth.width / 2,
    //   y: shapeCenterOnField.y
    // };

    ctx.textAlign = "start";
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;

    const lineHeight = config.workspace.fontSizeSmallest;
    ctx.wrapText(textWidth, pos.x, pos.y - (fontSize / 2), mTextWidth, lineHeight, font);
    ctx.wrapText(textHeight, pos.x + 2, pos.y + (fontSize / 2), mTextHeight, lineHeight, font);
  }

  renderBorders = (ctx,
                   staticOffset = null,
                   strokeTemplate= RENDER_TEMPLATES.default,
                   fillTemplate = RENDER_TEMPLATES.filledPrimary
  ) => {
    RenderParts.drawShapeBorders(ctx, staticOffset, strokeTemplate, fillTemplate, this.__shape);
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize
      || activeButton === SIDEBAR_BUTTONS_MENU.delete
    ) {
      RenderParts.drawHoveredBorders(ctx, staticOffset, this.__shape);

    // Highlight possibility to insert shape between lines
    } else if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
      || workspace.getMovingShape()
    ) {
      const movingShape = workspace.getMovingShape();
      //1. Highlight moving shape if their part ids are equal
      //2. Highlight upper shapes if we are dragging new upper cabinet shape
      //3. Highlight lower shapes if we are dragging new lower cabinet shape
      if ((movingShape && canShapeBeAutoShifted(workspace.getMovingShape(), this.__shape))
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper && this.__shape.partId === SHAPE_PART_ID.upper_cabinet_boxes)
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower && this.__shape.partId === SHAPE_PART_ID.lower_cabinet_boxes)
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall && this.__shape.partId === SHAPE_PART_ID.lower_cabinet_boxes)
      ) {
        const style = {
          lineWidth: 4,
          strokeStyle: COLOR.red,
          shadowBlur: 2,
          extendHoveredLine: 5
        };
        RenderParts.drawHoveredBorders(ctx, staticOffset, this.__shape, style);
      }
    }
  };

  renderHandles = (ctx) => {
    RenderParts.drawHandles(ctx, this.__shape)
  };

  getCrownMoldingPoints = () => {
    const points = this.__shape.getPointsPointField();

    return RenderCabinets.getDiagonalPointsForTheSquare(points, this.__crownMoldingParams.distance)
  }

  // renderCrownMolding = (ctx) => {
  //   if (this.__crownMoldingFeatureId) {
  //     const crownMoldingPoints = this.getCrownMoldingPoints();
  //     RenderCabinets.renderCrownMolding(ctx, crownMoldingPoints);
  //   }
  // };
}

export default ShapeCabinet
